import { render, staticRenderFns } from "./CustomCalendarForm.vue?vue&type=template&id=783c6d68&scoped=true&"
import script from "./CustomCalendarForm.vue?vue&type=script&lang=js&"
export * from "./CustomCalendarForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783c6d68",
  null
  
)

export default component.exports